import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import "./MenuItem.scss"
import _ from 'lodash';
import { getCurrencyFormat, LOCAL_STORAGE_ITEMS_NAMES } from '../../../../../utilities/helper';
const MenuItem = ({ layout, headerText, items, showHeader, itemRefs, category, href }) => {
    const { currency
    } = useSelector((state) => state.resturantData);
    const currencyFormat = getCurrencyFormat(currency);


    const selectedOrderType = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)).selectedOrderType
    const getThePrice = (price) => {
        let priceValue;

        switch (selectedOrderType) {
            case "delivery":
                priceValue = price?.DeliveryPrice;
                break;
            case "table":
                priceValue = price?.TablePrice;
                break;
            default:
                priceValue = price?.PickupPrice;
                break;
        }
        return currencyFormat(priceValue / 100);
    };


    const renderLayout = (menuItem) => {
        return (
            <div className="column-itemregal">
                <div className="column-itemregal-cont">
                    <div className="column-itemregal-cont-inner">
                        <div className="name">{menuItem?.Title?.en?.toCapitalFirst().replace(/\.+$/, '')}
                        </div>
                        <div className="details">{menuItem?.Description?.en?.toCapitalFirst()}</div>

                    </div>
                    <div className="price">
                        {getThePrice(menuItem?.PriceInfo?.Price)}
                    </div>
                </div>
                <img alt='' src={menuItem?.ImageURL !== "" ? menuItem?.ImageURL : "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM="} className="column-itemregal-img" />
            </div>
        )
    }
    return (
        <div className="MenuItem-DosaChutney">
            {showHeader &&
                <div className="MenuItem-DosaChutney-title" >{headerText?.toLowerCase() || ""}
                </div>}
            <div className="MenuItem-DosaChutney-column" ref={(el) => (itemRefs.current[category.MenuCategoryID] = el)}>
                {items.map(((menuItem, key) => {
                    return (
                        <div className="MenuItem-DosaChutney-column-styles" key={key}>
                            {renderLayout(menuItem)}
                        </div>
                    )
                }))}
            </div>
            <div className="MenuItem-DosaChutney-btn"
                onClick={() => {
                    if (href && href !== "") {
                        window.open(href, '_blank')
                    }
                }}>Order Now</div>
        </div >
    )
}
export default MenuItem